import crud from '@/crud/form/form'
import resources from '../../resources'

import components from './components'
import computed from './computed'
import data from './data'
import methods from './methods'
import mounted from './mounted'
import validations from './validations'

export default {
  components,
  computed,
  data,
  methods,
  mounted,
  validations,

  mixins: [crud, resources]
}



// WEBPACK FOOTER //
// ./src/app/professional/agenda/rules/form/resources/index.js